/* You Fly LA: cart icon count + booking straight to checkout (v79, 2026-10-23).
   1. Booking: when the Cowlendar calendar adds a booking to the cart (its iframe posts {action:'add_to_cart'}),
      the booking's cart data gets skip_cart = true, which is Cowlendar's own "go straight to checkout" flag
      (its app.js sends the visitor to /checkout once the cart add has finished). Fallback: if the page is still
      here 2.5 s after the cart count went up, this file opens /checkout itself.
   2. Cart icon: every [data-yfla-cart] link (snippets/yfla-deck-menu.liquid and sections/yh-hud-header.liquid)
      shows the cart's item count, updated after a booking and when the page comes back from the browser cache. */
(function () {
  'use strict';
  if (window.YFLA_cart) return;
  window.YFLA_cart = true;

  var count = 0;
  var start = document.querySelector('[data-yfla-cart]');
  if (start) count = parseInt(start.getAttribute('data-count') || '0', 10) || 0;

  function paint(n) {
    count = n;
    document.querySelectorAll('[data-yfla-cart]').forEach(function (a) {
      a.setAttribute('data-count', String(n));
      a.setAttribute('aria-label', n > 0 ? 'Cart, ' + n + (n === 1 ? ' item' : ' items') : 'Cart');
      var b = a.querySelector('[data-yfla-cart-n]');
      if (b) { b.textContent = n > 99 ? '99+' : String(n); b.hidden = n < 1; }
    });
  }
  function read() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && typeof c.item_count === 'number') { paint(c.item_count); return c.item_count; } return null; })
      .catch(function () { return null; });
  }
  function refresh() { if (/(^|;\s*)cart=/.test(document.cookie) || count > 0) read(); else paint(0); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  document.addEventListener('cart:update', function () { read(); });

  /* ---- booking -> checkout ---- */
  var armed = false, going = false;
  function go() {
    if (going) return;
    going = true;
    window.location.href = '/checkout';
  }
  function watch(base) {
    if (armed) return;
    armed = true;
    var tries = 0;
    (function poll() {
      if (going) return;
      tries++;
      read().then(function (n) {
        if (n !== null && n > base) { setTimeout(go, 2500); return; }
        if (tries < 25) setTimeout(poll, 600); else armed = false;
      });
    })();
  }
  window.addEventListener('message', function (e) {
    var host = '';
    try { host = new URL(e.origin).hostname; } catch (x) { return; }
    if (!/(^|\.)cowlendar\.com$/i.test(host)) return;
    var m = e.data || e.message;
    if (!m || typeof m !== 'object' || m.action !== 'add_to_cart') return;
    if (m.data && typeof m.data === 'object') m.data.skip_cart = true;
    setTimeout(function () {
      try { if (window._cow_ongoing_cart_data) window._cow_ongoing_cart_data.skip_cart = true; } catch (x) {}
    }, 0);
    watch(count);
  });
})();
